export enum ButtonVariant {
	Dark = "Dark",
	White = "White",
	Outlined = "Outlined",
	OutlinedWhite = "OutlinedWhite",
}
